import { useLocation } from "react-router-dom";
import { useEffect } from "react";

// Страница 404 - не найдено
const NotFound = () => {
  const location = useLocation();

  // Логируем попытку доступа к несуществующему маршруту
  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        {/* Заголовок ошибки 404 */}
        <h1 className="text-4xl font-bold mb-4">404</h1>
        {/* Сообщение об ошибке */}
        <p className="text-xl text-gray-600 mb-4">Упс! Страница не найдена</p>
        {/* Ссылка для возврата на главную */}
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Вернуться на главную
        </a>
      </div>
    </div>
  );
};

export default NotFound;
